import { render, staticRenderFns } from "./AddDrug.vue?vue&type=template&id=ee2217e8&scoped=true"
import script from "./AddDrug.vue?vue&type=script&lang=js"
export * from "./AddDrug.vue?vue&type=script&lang=js"
import style0 from "./AddDrug.vue?vue&type=style&index=0&id=ee2217e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2217e8",
  null
  
)

export default component.exports